export default {
  title: 'General',
  prescriptions: {
    title: 'Do you accept prescriptions from GPs?',
    description: 'Yes, any GP can utilise the Healistic e-prescriber web interface as long as they have been onboarded onto our platform. Once onboarded, they can issue an e-prescription during an in-person consultation within just a couple of clicks. After which, we will then fulfil the prescription order to get it delivered to the patient as quickly as possible.',
  },
  delivery: {
    title: 'Do you charge for delivery?',
    description: 'Yes, we charge £2.50 per delivery for prescription orders and £4.50 for orders via our app, which helps us to pay riders above the living wage for the region they are working in.',
  },
  saving: {
    title: 'How are you processing and saving my data?',
    description: 'We know privacy is important to you, and it’s important to us too. We make sure we’re fully GDPR compliant, and our Privacy Policy outlines all the details about how we process and save your data.',
  },
};
